// The InboxKit mark and wordmark. One source for every surface.

/** Envelope mark in ink; on the dark theme it turns to paper by itself. */
export function Logo({ className = 'h-6 w-6' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <rect x="1.5" y="4.5" width="21" height="15" rx="3" style={{ fill: 'var(--color-ink)' }} />
      <path
        d="M3.5 7l8.5 6 8.5-6"
        fill="none"
        style={{ stroke: 'var(--color-paper)' }}
        strokeOpacity=".9"
        strokeWidth="1.6"
      />
    </svg>
  );
}

/**
 * Mark + serif "InboxKit", with an optional product label ("Status", "Admin").
 * Text colour comes from the parent (`currentColor`).
 */
export function Wordmark({
  label,
  size = 'md',
  divider = true,
}: {
  label?: string | undefined;
  size?: 'sm' | 'md' | 'lg';
  divider?: boolean;
}) {
  const text = { sm: 'text-[19px]', md: 'text-[22px]', lg: 'text-[28px]' }[size];
  const mark = { sm: 'h-5 w-5', md: 'h-6 w-6', lg: 'h-7 w-7' }[size];
  return (
    <span className="inline-flex items-center gap-2.5">
      <Logo className={mark} />
      {divider && <span className="opacity-25">/</span>}
      <span className={`font-serif leading-none tracking-[-0.01em] ${text}`}>InboxKit</span>
      {label && (
        <span className="rounded-md border border-current/15 px-1.5 py-0.5 font-mono text-[10px] tracking-[0.14em] uppercase opacity-60">
          {label}
        </span>
      )}
    </span>
  );
}
